<!-- <div *ngIf="flightDetail?.booking_info?.booking_status.toUpperCase() !== 'PENDING PAYMENT'"
    class="w-full min-w-[300px] h-auto rounded-lg bg-palette-blue-50 border-1 border-palette-blue-600 !mb-2 !p-4">
    <p class="font-inter text-base font-semibold text-palette-gray-900">{{'FLIGHT.PAYMENT.CURRENCY_EXCHANGE' | translate}}</p>
    <div class="list-disc !ms-2">
        <li class="font-inter text-sm font-normal text-palette-gray-900">
            {{'FLIGHT.PAYMENT.PRIMARY_CURRENCY' | translate: { selectedCurrency: currency?.currency } }}
        </li>
        <li class="font-inter text-sm font-normal text-palette-gray-900">
            {{'FLIGHT.PAYMENT.CHOSEN_TO_PAY' | translate: { 
                currencyExchangeRate: flightDetail?.exchange_rate?.currency_exchange_rate.toUpperCase() } }}
        </li>
    </div>
    <p class="!mt-2 text-sm text-palette-gray-900">
        {{'FLIGHT.PAYMENT.RATE_ON_DATE' | translate }} 
        <span class="font-semibold">
            1 USD = {{ flightDetail?.exchange_rate?.exchange_rate_value  }} {{ flightDetail?.exchange_rate?.currency_exchange_rate }}
        </span>
    </p>
</div> -->

<div class="my-price-details-section w-full rounded-lg border border-palette-gray-200 bg-palette-base-white min-[1100px]:w-[384px]">
    <p class="!px-4 !pt-4 font-inter text-lg font-semibold text-palette-gray-900">
        {{ 'MY_FLIGHT_BOOKING_DETAIL.PRICE_DETAILS.TITLE' | translate }}
    </p>

    <!-- PRICE -->
    <ng-container *ngFor="let price of flightDetail?.[targetPriceDetails]?.price_details; let i = index">
        <div class="w-full !px-4 !pt-4 font-inter">
            <div class="flex flex-col !gap-3 border-b border-b-palette-gray-200 !pb-4">
                <div (click)="toggleCollapse(i, 'summary')" class="custom-bg flex cursor-pointer items-center justify-between !gap-2 py-[2px] !pl-2">
                    <h4 class="text-xs font-semibold uppercase text-palette-blue-600">
                        {{ (i == 0 ? 'FLIGHT.PAYMENT.DEPART' : 'FLIGHT.PAYMENT.RETURN') | translate }}
                    </h4>
                    <div class="flex items-center !gap-2">
                        <p class="text-sm font-medium text-palette-gray-900">
                            <span *ngIf="isSameCurrency(); then originCurrency; else exchangeCurrency"></span>
                            <ng-template #originCurrency>
                                <span *ngIf="!showMarketCurrencyOnly; then originFinal; else originFinalHistory"></span>
                                <ng-template #originFinal>
                                    {{
                                        price.final_price || 0
                                            | historyCurrency : flightDetail?.exchange_rate?.exchange_rate_value : flightDetail?.exchange_rate?.currency_exchange_rate : currency?.currency
                                    }}
                                </ng-template>
                                <ng-template #originFinalHistory>
                                    {{ transformCurrencyPayment(price.final_price || 0) }}
                                </ng-template>
                            </ng-template>
                            <ng-template #exchangeCurrency>
                                <app-price-format
                                    [price]="price.final_price">
                                </app-price-format>
                            </ng-template>
                        </p>
                        <span class="flex !h-4 !w-4 items-center justify-center">
                            <i class="text-base leading-4 {{ collapsedStates[i].summary ? 'sctr-icon-chevron-right' : 'sctr-icon-chevron-down' }}"></i>
                        </span>
                    </div>
                </div>
                <!-- TICKET DETAILS -->
                <div *ngIf="!collapsedStates[i].summary" class="flex flex-col !gap-2 font-inter text-sm">
                    <div class="font-semibold text-palette-gray-900">
                        {{ 'COMMON.TICKET_DETAILS' | translate }}
                    </div>
                    <ng-container *ngIf="showNewVersion; else oldVersion">
                        <ng-container *ngFor="let item of ['adult', 'child', 'infant']">
                            <div
                                *ngIf="(item === 'adult' && price.num_of_adults) || (item === 'child' && price.num_of_children) || (item === 'infant' && price.num_of_infants)"
                                class="flex flex-col !gap-2"
                            >
                                <!-- FINAL PRICE -->
                                <div (click)="toggleCollapse(i, item)" class="flex cursor-pointer items-center justify-between !gap-2">
                                    <div class="flex items-center !gap-2 text-palette-gray-900">
                                        <p class="first-letter:uppercase">
                                            <ng-container *ngIf="item === 'adult'">{{ 'COMMON.ADULT' | translate : { syntax: '' } }} x {{ price.num_of_adults }}</ng-container>
                                            <ng-container *ngIf="item === 'child'">{{ 'COMMON.CHILD' | translate }} x {{ price.num_of_children }}</ng-container>
                                            <ng-container *ngIf="item === 'infant'">{{ 'COMMON.INFANT' | translate }} x {{ price.num_of_infants }}</ng-container>
                                        </p>
                                        <span class="flex !h-4 !w-4 items-center justify-center">
                                            <i class="text-base leading-4 {{ collapsedStates[i][item] ? 'sctr-icon-chevron-right' : 'sctr-icon-chevron-down' }}"></i>
                                        </span>
                                    </div>
                                    <p class="font-medium text-palette-gray-900">
                                        <span *ngIf="isSameCurrency(); then originFarePrice; else exchangeFarePrice"></span>
                                        <ng-template #originFarePrice>
                                            <span *ngIf="!showMarketCurrencyOnly; then originFare; else originFareHistory"></span>
                                            <ng-template #originFare>
                                                {{
                                                    price.origin_fare_base[item] + price.origin_tax[item]
                                                        | historyCurrency : flightDetail?.exchange_rate?.exchange_rate_value : flightDetail?.exchange_rate?.currency_exchange_rate : currency?.currency
                                                }}
                                            </ng-template>
                                            <ng-template #originFareHistory>
                                                {{ transformCurrencyPayment(price.origin_fare_base[item] + price.origin_tax[item]) }}
                                            </ng-template>
                                        </ng-template>
                                        <ng-template #exchangeFarePrice>
                                            <app-price-format [price]="price.origin_fare_base[item] + price.origin_tax[item]"></app-price-format>
                                        </ng-template>
                                    </p>
                                </div>
                                <!-- DETAIL ADULT PRICE -->
                                <ng-container *ngIf="!collapsedStates[i][item]">
                                    <!-- ORIGINAL PRICE -->
                                    <div class="!pl-3 text-palette-gray-500">
                                        <app-price-display
                                            [label]="'COMMON.ORIGINAL_PRICE'"
                                            [price]="price.origin_fare_base[item]"
                                            [currency]="currency"
                                            [exchangeRate]="flightDetail.exchange_rate"
                                            [exchangeRate]="flightDetail.user_exchange_rate"
                                            [bookingStatus]="flightDetail?.booking_info?.booking_status"
                                        ></app-price-display>
                                    </div>
                                    <!-- ORIGIN TAX -->
                                    <div class="!pl-3 text-palette-gray-500">
                                        <app-price-display
                                            [label]="'COMMON.ORIGIN_TAX'"
                                            [price]="price.origin_tax[item]"
                                            [currency]="currency"
                                            [exchangeRate]="flightDetail.exchange_rate"
                                            [exchangeRate]="flightDetail.user_exchange_rate"
                                            [bookingStatus]="flightDetail?.booking_info?.booking_status"
                                        ></app-price-display>
                                    </div>
                                </ng-container>
                            </div>
                        </ng-container>
                        <div class="flex flex-col !gap-2">
                            <!-- TAXES, FEES AND CHARGES -->
                            <div (click)="toggleCollapse(i, 'taxes_charges')" class="flex cursor-pointer items-center justify-between !gap-2">
                                <div class="flex items-center !gap-2 text-palette-gray-900">
                                    <p class="first-letter:uppercase">
                                        {{ 'COMMON.TAX_FEE_CHARGE' | translate }}
                                    </p>
                                    <span class="flex !h-4 !w-4 items-center justify-center">
                                        <i class="text-base leading-4 {{ collapsedStates[i].taxes_charges ? 'sctr-icon-chevron-right' : 'sctr-icon-chevron-down' }}"></i>
                                    </span>
                                </div>
                                <p class="font-medium text-palette-gray-900">
                                    <span *ngIf="isSameCurrency(); then originChargesCurrency; else exchangeChargesCurrency"></span>
                                    <ng-template #originChargesCurrency>
                                        <span *ngIf="!showMarketCurrencyOnly; then originCharges; else originChargesHistory"></span>
                                        <ng-template #originCharges>
                                            {{ (price?.tax?.['adult'] ?? 0) + (price?.tax?.['child'] ?? 0) + (price?.tax?.['infant'] ?? 0) +
                                        (price?.fee?.['adult'] ?? 0) + (price?.fee?.['child'] ?? 0) + (price?.fee?.['infant'] ?? 0) +
                                        (price?.itinerary_fee ?? 0) +
                                        (price?.ticket_fee?.['adult'] ?? 0) + (price?.ticket_fee?.['child'] ?? 0) + (price?.ticket_fee ?.['infant'] ?? 0) +
                                        (price?.charge?.['adult'] ?? 0) + (price?.charge?.['child'] ?? 0) + (price?.charge?.['infant'] ?? 0) | 
                                        historyCurrency: flightDetail?.exchange_rate?.exchange_rate_value : flightDetail?.exchange_rate?.currency_exchange_rate : currency?.currency }}
                                        </ng-template>
                                        <ng-template #originChargesHistory>
                                            {{transformCurrencyPayment((price?.tax?.['adult'] ?? 0) + (price?.tax?.['child'] ?? 0) + (price?.tax?.['infant'] ?? 0) +
                                        (price?.fee?.['adult'] ?? 0) + (price?.fee?.['child'] ?? 0) + (price?.fee?.['infant'] ?? 0) +
                                        (price?.itinerary_fee ?? 0) +
                                        (price?.ticket_fee?.['adult'] ?? 0) + (price?.ticket_fee?.['child'] ?? 0) + (price?.ticket_fee ?.['infant'] ?? 0) +
                                        (price?.charge?.['adult'] ?? 0) + (price?.charge?.['child'] ?? 0) + (price?.charge?.['infant'] ?? 0))}}
                                        </ng-template>
                                    </ng-template>
                                    <ng-template #exchangeChargesCurrency>
                                        <app-price-format [price]="(price?.tax?.['adult'] ?? 0) + (price?.tax?.['child'] ?? 0) + (price?.tax?.['infant'] ?? 0) +
                                            (price?.fee?.['adult'] ?? 0) + (price?.fee?.['child'] ?? 0) + (price?.fee?.['infant'] ?? 0) +
                                            (price?.itinerary_fee ?? 0) +
                                            (price?.ticket_fee?.['adult'] ?? 0) + (price?.ticket_fee?.['child'] ?? 0) + (price?.ticket_fee ?.['infant'] ?? 0) +
                                            (price?.charge?.['adult'] ?? 0) + (price?.charge?.['child'] ?? 0) + (price?.charge?.['infant'] ?? 0)">
                                        </app-price-format>
                                    </ng-template>
                                </p>
                            </div>
                            <ng-container *ngIf="!collapsedStates[i].taxes_charges">
                                <!-- TAXES -->
                                <div class="!pl-3 text-palette-gray-700">
                                    <app-price-display
                                        [label]="'COMMON.TAXES'"
                                        [price]="(price?.tax?.['adult'] ?? 0) + (price?.tax?.['child'] ?? 0) + (price?.tax?.['infant'] ?? 0)"
                                        [currency]="currency"
                                        [exchangeRate]="flightDetail.exchange_rate"
                                        [bookingStatus]="flightDetail?.booking_info?.booking_status"
                                    ></app-price-display>
                                </div>
                                <ng-container *ngFor="let item of ['adult', 'child', 'infant']">
                                    <ng-container *ngIf="(item === 'adult' && price.num_of_adults) || (item === 'child' && price.num_of_children) || (item === 'infant' && price.num_of_infants)">
                                        <div class="!pl-6 text-palette-gray-500">
                                            <app-price-display
                                                [label]="item === 'adult' ? 'FLIGHT.PAYMENT.ADULT' : item === 'child' ? 'COMMON.CHILD' : 'COMMON.INFANT'"
                                                [numLabel]="item === 'adult' ? price.num_of_adults : item === 'child' ? price.num_of_children : price.num_of_infants"
                                                [price]="price?.tax?.[item]"
                                                [currency]="currency"
                                                [exchangeRate]="flightDetail.exchange_rate"
                                                [bookingStatus]="flightDetail?.booking_info?.booking_status"
                                            ></app-price-display>
                                        </div>
                                    </ng-container>
                                </ng-container>
                                <!-- Fee by ticket -->
                                <div class="!pl-3 text-palette-gray-700">
                                    <app-price-display
                                        [label]="'FEE.FEE_BY_TICKET'"
                                        [price]="(price?.ticket_fee?.['adult'] ?? 0) + (price?.ticket_fee?.['child'] ?? 0) + (price?.ticket_fee ?.['infant'] ?? 0)"
                                        [currency]="currency"
                                        [exchangeRate]="flightDetail.exchange_rate"
                                        [bookingStatus]="flightDetail?.booking_info?.booking_status"
                                    ></app-price-display>
                                </div>
                                <ng-container *ngFor="let item of ['adult', 'child', 'infant']">
                                    <ng-container *ngIf="(item === 'adult' && price.num_of_adults) || (item === 'child' && price.num_of_children) || (item === 'infant' && price.num_of_infants)">
                                        <div class="!pl-6 text-palette-gray-500">
                                            <app-price-display
                                                [label]="item === 'adult' ? 'FLIGHT.PAYMENT.ADULT' : item === 'child' ? 'COMMON.CHILD' : 'COMMON.INFANT'"
                                                [numLabel]="item === 'adult' ? price.num_of_adults : item === 'child' ? price.num_of_children : price.num_of_infants"
                                                [price]="price?.ticket_fee?.[item]"
                                                [currency]="currency"
                                                [exchangeRate]="flightDetail.exchange_rate"
                                                [bookingStatus]="flightDetail?.booking_info?.booking_status"
                                            ></app-price-display>
                                        </div>
                                    </ng-container>
                                </ng-container>
                                <!-- Fee by intinerary -->
                                <div class="!pl-3 text-palette-gray-700">
                                    <app-price-display
                                        [label]="'FEE.FEE_BY_ITINERARY'"
                                        [price]="price?.itinerary_fee"
                                        [currency]="currency"
                                        [exchangeRate]="flightDetail.exchange_rate"
                                        [bookingStatus]="flightDetail?.booking_info?.booking_status"
                                    ></app-price-display>
                                </div>
                                <!-- SOCTRIP FEE-->
                                <div class="!pl-3 text-palette-gray-700">
                                    <app-price-display
                                        [label]="'COMMON.SOCTRIP_FEE'"
                                        [price]="(price?.charge?.['adult'] ?? 0) + (price?.charge?.['child'] ?? 0) + (price?.charge?.['infant'] ?? 0)"
                                        [currency]="currency"
                                        [exchangeRate]="flightDetail.exchange_rate"
                                        [bookingStatus]="flightDetail?.booking_info?.booking_status"
                                    ></app-price-display>
                                </div>
                                <ng-container *ngFor="let item of ['adult', 'child', 'infant']">
                                    <ng-container *ngIf="(item === 'adult' && price.num_of_adults) || (item === 'child' && price.num_of_children) || (item === 'infant' && price.num_of_infants)">
                                        <div class="!pl-6 text-palette-gray-500">
                                            <app-price-display
                                                [label]="item === 'adult' ? 'FLIGHT.PAYMENT.ADULT' : item === 'child' ? 'COMMON.CHILD' : 'COMMON.INFANT'"
                                                [numLabel]="item === 'adult' ? price.num_of_adults : item === 'child' ? price.num_of_children : price.num_of_infants"
                                                [price]="price?.charge?.[item]"
                                                [currency]="currency"
                                                [exchangeRate]="flightDetail.exchange_rate"
                                                [userExchangeRate]="flightDetail.user_exchange_rate"
                                                [bookingStatus]="flightDetail?.booking_info?.booking_status"
                                                [showMarketCurrencyOnly]="showMarketCurrencyOnly"
                                            ></app-price-display>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                            <!-- ADJUSTMENT -->
                            <div class="!text-palette-gray-900">
                                <app-price-display
                                    [label]="'COMMON.ADJUSTMENT'"
                                    [price]="price?.adjustment_price"
                                    [currency]="currency"
                                    [exchangeRate]="flightDetail.exchange_rate"
                                    [userExchangeRate]="flightDetail.user_exchange_rate"
                                    [bookingStatus]="flightDetail?.booking_info?.booking_status"
                                    [showMarketCurrencyOnly]="showMarketCurrencyOnly"
                                ></app-price-display>
                            </div>
                            <!-- MEMBERSHIP -->
                            <div class="!text-palette-gray-900">
                                <app-price-display
                                    [label]="'COMMON.MEMBERSHIP'"
                                    [price]="price?.membership_discount"
                                    [currency]="currency"
                                    [exchangeRate]="flightDetail.exchange_rate"
                                    [bookingStatus]="flightDetail?.booking_info?.booking_status"
                                    [deduct]="true"
                                    [showMarketCurrencyOnly]="showMarketCurrencyOnly"
                                ></app-price-display>
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #oldVersion>
                        <ng-container *ngFor="let item of ['adult', 'child', 'infant']">
                            <div
                                *ngIf="(item === 'adult' && price.num_of_adults) || (item === 'child' && price.num_of_children) || (item === 'infant' && price.num_of_infants)"
                                class="flex flex-col !gap-2"
                            >
                                <!-- FINAL PRICE -->
                                <div class="flex cursor-pointer items-center justify-between !gap-2">
                                    <p class="first-letter:uppercase">
                                        <ng-container *ngIf="item === 'adult'">{{ 'COMMON.ADULT' | translate : { syntax: '' } }} x {{ price.num_of_adults }}</ng-container>
                                        <ng-container *ngIf="item === 'child'">{{ 'COMMON.CHILD' | translate }} x {{ price.num_of_children }}</ng-container>
                                        <ng-container *ngIf="item === 'infant'">{{ 'COMMON.INFANT' | translate }} x {{ price.num_of_infants }}</ng-container>
                                    </p>
                                    <p class="font-medium text-palette-gray-900">
                                        <span *ngIf="isSameCurrency(); then originFarePrice; else exchangeFarePrice"></span>
                                        <ng-template #originFarePrice>
                                            <span *ngIf="!showMarketCurrencyOnly; then originFarePricePayment; else originFarePricePaymentHistory"></span>
                                            <ng-template #originFarePricePayment>
                                                {{ (price?.[item+'_fare_price'] ?? 0) | historyCurrency: flightDetail?.exchange_rate?.exchange_rate_value : flightDetail?.exchange_rate?.currency_exchange_rate : currency?.currency }}
                                            </ng-template>
                                            <ng-template #originFarePricePaymentHistory>
                                                {{transformCurrencyPayment((price?.[item+'_fare_price'] ?? 0))}}
                                            </ng-template>
                                        </ng-template>
                                        <ng-template #exchangeFarePrice>
                                            <app-price-format [price]="(price?.[item+'_fare_price'] ?? 0)"></app-price-format>
                                        </ng-template>
                                    </p>
                                </div>
                            </div>
                        </ng-container>
                        <!-- TAXES, FEES AND CHARGES -->
                        <div class="flex cursor-pointer items-center justify-between !gap-2">
                            <p class="first-letter:uppercase">
                                {{ 'COMMON.TAXES_AND_CHARGES' | translate }}
                            </p>
                            <p class="font-medium text-palette-gray-900">
                                <span *ngIf="isSameCurrency(); then originChargesCurrency; else exchangeChargesCurrency"></span>
                                <ng-template #originChargesCurrency>
                                    <span *ngIf="!showMarketCurrencyOnly; then originChargesPayment; else originChargesPaymentHistory"></span>
                                    <ng-template #originChargesPayment>
                                        {{
                                            price?.taxes_charges ?? 0
                                                | historyCurrency : flightDetail?.exchange_rate?.exchange_rate_value : flightDetail?.exchange_rate?.currency_exchange_rate : currency?.currency
                                        }}
                                    </ng-template>
                                    <ng-template #originChargesPaymentHistory>
                                        {{ transformCurrencyPayment(price?.taxes_charges ?? 0) }}
                                    </ng-template>
                                </ng-template>
                                <ng-template #exchangeChargesCurrency>
                                    <app-price-format [price]="(price?.taxes_charges ?? 0)"></app-price-format>
                                </ng-template>
                            </p>
                        </div>
                    </ng-template>
                </div>

                <!-- Add-ons -->
                <div
                    *ngIf="!collapsedStates[i].summary && (serviceData[i].numSeat || serviceData[i].numMeal || serviceData[i]?.numExtraBaggage)"
                    class="flex flex-col !gap-2 border-t border-dashed border-palette-gray-200 !pt-2"
                >
                    <p class="text-sm font-semibold text-palette-gray-900">
                        {{ 'COMMON.ADD_ONS' | translate }}
                    </p>
                    <div *ngIf="serviceData[i].numExtraBaggage" class="flex justify-between">
                        <p class="text-sm text-palette-gray-700">{{ 'FLIGHT.PAYMENT.EXTRA_BAGGAGE_1' | translate }} x {{ serviceData[i].numExtraBaggage }}</p>
                        <p class="text-sm font-medium text-palette-amber-600">
                            <span *ngIf="isSameCurrency(); then originBaggageCurrency; else exchangeBaggageCurrency"></span>
                            <ng-template #originBaggageCurrency>
                                <span *ngIf="!showMarketCurrencyOnly; then originBaggage; else originBaggageHistory"></span>
                                <ng-template #originBaggage>
                                    {{
                                        serviceData[i].totalExtraBaggage
                                            | historyCurrency : flightDetail?.exchange_rate?.exchange_rate_value : flightDetail?.exchange_rate?.currency_exchange_rate : currency?.currency
                                    }}
                                </ng-template>
                                <ng-template #originBaggageHistory>
                                    {{ transformCurrencyPayment(serviceData[i].totalExtraBaggage) }}
                                </ng-template>
                            </ng-template>
                            <ng-template #exchangeBaggageCurrency>
                                <app-price-format class="text-sm font-medium text-palette-amber-600"
                                    [price]="serviceData[i].totalExtraBaggage"></app-price-format>
                            </ng-template>
                        </p>
                    </div>
                    <div *ngIf="serviceData[i].numSeat" class="flex justify-between">
                        <p class="text-sm text-palette-gray-700">{{ 'FLIGHT.PAYMENT.SEAT_SELECTION' | translate }} x {{ serviceData[i].numSeat }}</p>
                        <p class="text-sm font-medium text-palette-amber-600">
                            <span *ngIf="isSameCurrency(); then originSeatCurrency; else exchangeSeatCurrency"></span>
                            <ng-template #originSeatCurrency>
                                <span *ngIf="!showMarketCurrencyOnly; then originSeat; else originSeatHistory"></span>
                                <ng-template #originSeat>
                                    {{
                                        serviceData[i].totalSeat
                                            | historyCurrency : flightDetail?.exchange_rate?.exchange_rate_value : flightDetail?.exchange_rate?.currency_exchange_rate : currency?.currency
                                    }}
                                </ng-template>
                                <ng-template #originSeatHistory>
                                    {{ transformCurrencyPayment(serviceData[i].totalSeat) }}
                                </ng-template>
                            </ng-template>
                            <ng-template #exchangeSeatCurrency >
                                <app-price-format class="text-sm font-medium text-palette-amber-600"
                                    [price]="serviceData[i].totalSeat"></app-price-format>
                            </ng-template>
                        </p>
                    </div>
                    <div *ngIf="serviceData[i].numMeal" class="font-inter">
                        <div class="flex flex-col !gap-1">
                            <div class="flex justify-between !gap-4">
                                <p class="text-sm font-normal text-palette-gray-700">{{ 'FLIGHT.PAYMENT.MEAL' | translate }} x {{ serviceData[i].numMeal }}</p>
                                <span *ngIf="isSameCurrency(); then originMealCurrency; else exchangeMealCurrency"></span>
                                <ng-template #originMealCurrency>
                                    <span *ngIf="!showMarketCurrencyOnly; then originMeal; else originMealHistory"></span>
                                    <ng-template #originMeal>
                                        {{
                                            serviceData[i].totalMeal
                                                | historyCurrency : flightDetail?.exchange_rate?.exchange_rate_value : flightDetail?.exchange_rate?.currency_exchange_rate : currency?.currency
                                        }}
                                    </ng-template>
                                    <ng-template #originMealHistory>
                                        {{ transformCurrencyPayment(serviceData[i].totalMeal) }}
                                    </ng-template>
                                </ng-template>
                                <ng-template #exchangeMealCurrency>
                                    <app-price-format
                                        class="text-sm font-medium text-palette-amber-600 whitespace-nowrap"
                                        [price]="serviceData[i].totalMeal"> </app-price-format>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>

    <!-- Soctrip service -->
    <div class="!px-4 !pt-4">
        <p class="!mb-2 text-sm font-semibold capitalize text-palette-gray-900">
            {{ 'COMMON.SOCTRIP_SERVICE' | translate }}
        </p>
        <div class="flex flex-col !gap-1">
            <div class="flex justify-between !gap-4">
                <p class="text-sm text-palette-gray-900">{{ 'COMMON.PAYMENT_FEE' | translate }}</p>
                <p class="font-inter text-xs font-medium uppercase leading-[18px] text-system-success-700">{{ 'FLIGHT.VIEW_DETAILS_SIDEBAR.FREE' | translate }}</p>
            </div>
        </div>
        <div *ngIf="flightDetail?.price_details?.order_fee - flightDetail?.price_details?.order_fee_after_membership !== null" class="!mt-2 flex flex-col !gap-1">
            <div>
                <div class="flex items-center justify-between !gap-1">
                    <div class="flex !gap-1 items-center">
                        <p class="text-sm text-palette-gray-900">{{ 'COMMON.SERVICE_CHARGE' | translate }}</p>
                        <div class="relative">
                            <i [tooltip]="'COMMON.SERVICE_CHARGE_DESC' | translate" [theme]="TooltipTheme.LIGHT" class="sctr-icon-alert-circle cursor-pointer text-palette-gray-500"></i>
                        </div>
                        <i *ngIf="!isCollapsedServiceChange" (click)="collapseServiceChange()" class="sctr-icon-chevron-right cursor-pointer text-base leading-4"></i>
                        <i *ngIf="isCollapsedServiceChange" (click)="collapseServiceChange()" class="sctr-icon-chevron-down cursor-pointer text-base leading-4"></i>
                    </div>
                    <div class="text-sm !font-medium text-palette-gray-900">
                        <app-price-display
                            *ngIf="flightDetail?.price_details?.order_fee - (flightDetail?.price_details?.order_fee - flightDetail?.price_details?.order_fee_after_membership)"
                            [price]="flightDetail?.price_details?.order_fee - (flightDetail?.price_details?.order_fee - flightDetail?.price_details?.order_fee_after_membership)"
                            [currency]="currency"
                            [exchangeRate]="flightDetail.exchange_rate"
                            [bookingStatus]="flightDetail?.booking_info?.booking_status"
                        ></app-price-display>
                        <p
                            *ngIf="!(flightDetail?.price_details?.order_fee - (flightDetail?.price_details?.order_fee - flightDetail?.price_details?.order_fee_after_membership))"
                            class="font-inter text-xs font-medium uppercase leading-[18px] text-system-success-700"
                        >
                            {{ 'FLIGHT.VIEW_DETAILS_SIDEBAR.FREE' | translate }}
                        </p>
                    </div>
                </div>
                <div class="!pl-3" *ngIf="isCollapsedServiceChange">
                    <div class="!mt-2 flex justify-between">
                        <span class="font-inter text-sm text-palette-gray-500">{{ 'COMMON.ORIFIN_FEE' | translate }}</span>
                        <div class="text-sm !font-normal text-palette-gray-500">
                            <app-price-display
                                *ngIf="flightDetail?.price_details?.order_fee"
                                [price]="flightDetail?.price_details?.order_fee"
                                [currency]="currency"
                                [exchangeRate]="flightDetail.exchange_rate"
                                [bookingStatus]="flightDetail?.booking_info?.booking_status"
                            ></app-price-display>
                            <p *ngIf="!flightDetail?.price_details?.order_fee" class="font-inter text-xs font-medium uppercase leading-[18px] text-system-success-700">
                                {{ 'FLIGHT.VIEW_DETAILS_SIDEBAR.FREE' | translate }}
                            </p>
                        </div>
                    </div>
                    <div class="!mt-2 flex justify-between">
                        <span class="font-inter text-sm text-palette-gray-500">{{ 'COMMON.MEMBERSHIP_SERVICE_CHARGE' | translate }}</span>
                        <div class="text-sm !font-normal text-palette-gray-500">
                            <app-price-display
                                [price]="flightDetail?.price_details?.order_fee - flightDetail?.price_details?.order_fee_after_membership"
                                [currency]="currency"
                                [deduct]="true"
                                [exchangeRate]="flightDetail.exchange_rate"
                                [bookingStatus]="flightDetail?.booking_info?.booking_status"
                            ></app-price-display>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Voucher -->
    <div *ngIf="flightDetail?.price_details?.vouchers?.length" class="!px-4 !pt-4">
        <p class="!mb-2 text-sm font-semibold capitalize text-palette-gray-900">
            {{ 'FLIGHT.PAYMENT.VOUCHER' | translate }}
        </p>
        <div class="flex flex-col !gap-1">
            <div *ngFor="let item of flightDetail?.price_details?.vouchers">
                <div class="flex items-center justify-between">
                    <div class="flex items-center gap-1 rounded-2xl bg-palette-emerald-50 !py-[2px] !pl-[6px] !pr-2">
                        <img class="h-[12px] w-[12px]" src="assets/images/flight-view-details/checked-voucher.svg" alt="" />
                        <span class="font-inter text-xs font-medium uppercase leading-[18px] text-system-success-700">{{ item.voucher_code }}</span>
                    </div>
                    <div class="flex items-center">
                        <span class="mr-[4px] text-xs font-semibold !leading-[18px] text-palette-gray-900">-</span>
                        <div class="font-inter text-sm font-semibold text-palette-gray-900">
                            <span
                            *ngIf="isSameCurrency(); then originDiscountCurrency; else exchangeDiscountCurrency"></span>
                        <ng-template #originDiscountCurrency>
                         
                                     <span
                                        *ngIf="!showMarketCurrencyOnly; then originDiscount; else originDiscountHistory"></span>
                                        <ng-template #originDiscount > 
                                              {{ (item.discount_price || 0) | historyCurrency: flightDetail?.exchange_rate?.exchange_rate_value : flightDetail?.exchange_rate?.currency_exchange_rate : currency?.currency }}
                                        </ng-template>
                                        <ng-template #originDiscountHistory >
                                            {{transformCurrencyPayment((item.discount_price || 0))}}
                                        </ng-template>                        
                        </ng-template>
                        <ng-template #exchangeDiscountCurrency>
                            <app-price-format [price]="item.discount_price"></app-price-format>
                        </ng-template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Total -->
    <div class="flex flex-col !gap-1 !p-4">
        <ng-container *ngIf="isSameCurrency(); else exchangeTotalCurrency">
            <div class="flex items-center justify-between">
                <h4 class="font-inter text-base font-semibold leading-6 text-palette-gray-900">{{ 'COMMON.TOTAL' | translate }}</h4>
                <div class="flex items-center !gap-1">
                    <span class="font-inter text-xl font-semibold leading-[30px] text-palette-orange-dark-600">
                        <span *ngIf="!showMarketCurrencyOnly; then originTotal; else originTotalHistory"></span>
                        <ng-template #originTotal>
                            {{
                                flightDetail?.price_details.total_price
                                    | historyCurrency : flightDetail?.exchange_rate?.exchange_rate_value : flightDetail?.exchange_rate?.currency_exchange_rate : currency?.currency
                            }}
                        </ng-template>
                        <ng-template #originTotalHistory>
                            {{ transformCurrencyPayment(flightDetail?.price_details.total_price) }}
                        </ng-template>
                    </span>
                    <!-- <i (mouseenter)="op.show($event)" (mouseleave)="op.hide()" class="sctr-icon-info-circle text-palette-blue-600 hover:cursor-pointer">
                        <p-overlayPanel #op>
                            <div *ngIf="flightDetail?.booking_info?.booking_status.toUpperCase() !== 'PENDING PAYMENT'"
                                class="w-full min-w-[300px] max-w-[370px] h-auto rounded-lg bg-palette-blue-50 border-1 border-palette-blue-600 !p-4">
                                <p class="font-inter text-base font-semibold text-palette-gray-900">{{'FLIGHT.PAYMENT.CURRENCY_EXCHANGE' | translate}}</p>
                                <div class="list-disc !ms-2">
                                    <li class="font-inter text-sm font-normal text-palette-gray-900">
                                        {{'FLIGHT.PAYMENT.PRIMARY_CURRENCY' | translate: { selectedCurrency: currency?.currency } }}
                                    </li>
                                    <li class="font-inter text-sm font-normal text-palette-gray-900">
                                        {{'FLIGHT.PAYMENT.CHOSEN_TO_PAY' | translate: { 
                                            currencyExchangeRate: flightDetail?.exchange_rate?.currency_exchange_rate.toUpperCase() } }}
                                    </li>
                                </div>
                                <p class="!mt-2 text-sm text-palette-gray-900">
                                    {{'FLIGHT.PAYMENT.RATE_ON_DATE' | translate }} 
                                    <span class="font-semibold">
                                        1$ = {{ flightDetail?.exchange_rate?.exchange_rate_value  }} {{ flightDetail?.exchange_rate?.currency_exchange_rate }}
                                    </span>
                                </p>
                            </div>
                        </p-overlayPanel>
                    </i> -->
                </div>
            </div>
            <div class="text-end text-sm text-palette-gray-600">
                ({{ 'FLIGHT.PAYMENT.INCLUDED' | translate }}
                <span class="font-semibold text-palette-gray-900">
                    <span *ngIf="!showMarketCurrencyOnly; then originIncluded; else originIncludedHistory"></span>
                    <ng-template #originIncluded>
                        {{
                            flightDetail?.price_details?.taxes_and_fees || 0
                                | historyCurrency : flightDetail?.exchange_rate?.exchange_rate_value : flightDetail?.exchange_rate?.currency_exchange_rate : currency?.currency
                        }}
                    </ng-template>
                    <ng-template #originIncludedHistory>
                        {{ transformCurrencyPayment(flightDetail?.price_details?.taxes_and_fees || 0) }}
                    </ng-template>
                </span>
                {{ 'FLIGHT.PAYMENT.TAXES_AND_FEES' | translate }})
            </div>
        </ng-container>
        <ng-template #exchangeTotalCurrency>
            <div class="flex justify-between items-center">
                <h4 class="text-palette-gray-900 font-inter text-base font-semibold leading-6"> {{"COMMON.TOTAL" | translate}} </h4>
                <span class="text-palette-orange-dark-600 font-inter text-xl font-semibold leading-[30px]">
                    <app-price-format [price]="flightDetail?.price_details.total_price"></app-price-format>
                </span>
            </div>
            <div class="text-palette-gray-600 text-sm text-end">
                ({{ 'FLIGHT.PAYMENT.INCLUDED' | translate}} 
                <span class="text-palette-gray-900 font-semibold whitespace-nowrap">
                    <app-price-format [price]="flightDetail?.price_details?.taxes_and_fees"></app-price-format>
                </span> 
                {{ 'FLIGHT.PAYMENT.TAXES_AND_FEES' | translate}})
            </div>
        </ng-template>
    </div>

    <!-- Buttons -->
    <!-- <div class="!p-4 flex flex-col !gap-3 border-t-[1px] border-palette-gray-200">
        <button
            class="h-[44px] bg-palette-base-white hover:bg-palette-gray-50 border border-palette-gray-300 rounded-lg">
            <common-icon-text class="flex items-center gap-2 justify-center" [iconStyle]="'sctr-icon-file-x-02'"
                (click)="showCancelPopup()"
                [icon]="'text-xl font-medium text-palette-gray-900'"
                [text]="'MY_FLIGHT_BOOKING_DETAIL.CANCEL_BOOKING' | translate"
                [textStyle]="'font-inter text-palette-gray-900 text-sm font-semibold leading-5'">
            </common-icon-text>
        </button>
        <button class="h-[44px] bg-palette-base-white hover:bg-palette-gray-50 border border-palette-gray-300 rounded-lg">
            <common-icon-text 
                (click)="showReschedulePopup()"
                class="flex items-center gap-2 justify-center"
                [iconStyle]="'sctr-icon-calendar'"
                [icon]="'text-xl font-medium text-palette-gray-900'"
                [text]="'MY_FLIGHT_BOOKING_DETAIL.REQUEST_RESCHEDULE' | translate"
                [textStyle]="'font-inter text-palette-gray-900 text-sm font-semibold leading-5'">
            </common-icon-text>
        </button>
    </div> -->
</div>

<app-cancel-booking
    class="fixed bottom-0 left-0 right-0 top-0 z-[9999] h-screen !overflow-hidden !overflow-x-hidden !overflow-y-hidden bg-palette-base-black bg-opacity-40"
    *ngIf="isShowCancelPopup"
    (closePopup)="closeCancelPopup()"
></app-cancel-booking>
<app-reschedule-booking *ngIf="isShowReschedulePopup" (close)="closeReschedulePopup()"></app-reschedule-booking>
